import {
  Component,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
@Component({
  selector: 'app-leads-submission',
  templateUrl: './leads-submission.component.html',
  styleUrls: ['./leads-submission.component.scss'],
})
export class LeadsSubmissionComponent {
  currentLanguage
  initialUrlPath: string = '';

  constructor(
    private translate: TranslateService,
    private router:Router,
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
  ) {
  }
  ngAfterViewInit(){
    this.translate.onLangChange.subscribe(res=>{
      this.router.navigate(['pre-signup/'+res.lang]);
    });
  }

  ngOnInit() {
    this.initialUrlPath = (this.activatedRoute.snapshot as any)._routerState.url
    this.currentLanguage = this.activatedRoute.snapshot.routeConfig.path || 'ar';
    this.translate.use(this.currentLanguage);
    localStorage.setItem('language', this.currentLanguage);
    this.languageService.languageUpdated.emit(this.currentLanguage);
  }
}
